import { cloneElement, CSSProperties, ReactElement, ReactNode } from 'react';
import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Text } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';
import { isMobileResolution } from '~/utils/common';

import { ShadowBox } from './styled';

interface ContentContainerProps {
  title?: string;
  subTitle?: string;
  titleIcon?: ReactElement;
  children?: ReactNode;
  rightComponent?: ReactNode;
  titleFont?: number;
  resetShadow?: boolean;
  resetPadding?: boolean;
  inlineFlex?: boolean;
  additionalSubTitle?: string;
  chipComponent?: ReactNode;
  chipRelative?: CSSProperties['position'];
  containerStyles?: SxProps;
  [key: string]: any; // For spreading any other props onto Box
}

function ContentContainer({
  title,
  subTitle,
  titleIcon,
  children,
  rightComponent,
  titleFont,
  resetShadow,
  resetPadding,
  inlineFlex,
  additionalSubTitle,
  chipComponent,
  chipRelative,
  containerStyles = {},
  ...rest
}: ContentContainerProps) {
  return (
    <ShadowBox sx={{ boxShadow: resetShadow ? 0 : 2, borderRadius: '20px', ...containerStyles }}>
      <Box
        display={title ? (inlineFlex ? 'inline-flex' : 'flex') : 'none'}
        flexDirection="row"
        padding={resetPadding ? 0 : 2}
        sx={{ position: chipRelative || 'static' }}
      >
        <Box display="flex" alignItems="center">
          {!!titleIcon && (
            <Box sx={{ mr: 2, background: COLORS.blue50, padding: '8px', borderRadius: '12px', display: 'flex' }}>
              {cloneElement(titleIcon, {
                sx: { fontSize: 35, color: COLORS.blue },
              })}
            </Box>
          )}
          <Box display="flex" flexDirection="column">
            <Text variant="h3" sx={{ mr: titleFont ? 2.5 : 0, display: 'flex', color: COLORS.textMain }}>
              {title} {chipComponent}
            </Text>
            {!!subTitle && (
              <Text variant="input15" sx={{ color: COLORS.grey400 }}>
                {subTitle}
              </Text>
            )}
          </Box>
        </Box>
        {rightComponent}

        {!!additionalSubTitle && !isMobileResolution && (
          <Typography sx={{ ml: 3, mt: 1 }} fontSize={14} color={COLORS.black06}>
            {additionalSubTitle}
          </Typography>
        )}
      </Box>

      {!!additionalSubTitle && isMobileResolution && (
        <Typography sx={{ mt: 1, mb: 2 }} fontSize={14} color={COLORS.black06}>
          {additionalSubTitle}
        </Typography>
      )}

      <Box {...rest}>{children}</Box>
    </ShadowBox>
  );
}

export default ContentContainer;
